// extracted by mini-css-extract-plugin
export var container = "_f9-0";
export var icon = "_f9-1";
export var text = "_f9-2";